<template>
  <main class="page-content">
      <!-- Begin Uren's Account Page Area -->
      <div class="account-page-area">
        <div class="container">
          <div class="card">
            <div class="card-header">
              <div class="row m-auto">
              <div class="col-12">
                  <ul class="nav myaccount-tab-trigger row" id="account-page-tab" role="tablist">
                    <li class="nav-item">
                      <a class="nav-link active" id="account-dashboard-tab" data-toggle="tab" href="#account-dashboard"
                        role="tab" aria-controls="account-dashboard" aria-selected="true">Dashboard</a>
                    </li>
                    <li class="nav-item">
                      <a class="nav-link" id="account-orders-tab" data-toggle="tab" href="#account-orders" role="tab"
                        aria-controls="account-orders" aria-selected="false">Orders</a>
                    </li>
                    <li class="nav-item">
                      <a class="nav-link" id="account-address-tab" data-toggle="tab" href="#account-address" role="tab"
                        aria-controls="account-address" aria-selected="false">Addresses</a>
                    </li>
                    <li class="nav-item">
                      <a class="nav-link" id="account-details-tab" data-toggle="tab" href="#account-details" role="tab"
                        aria-controls="account-details" aria-selected="false">Details</a>
                    </li>
                    <!-- <li class="nav-item col-sm-12">
                      <router-link class="nav-link" id="account-logout-tab" to="/login" role="tab"
                        aria-selected="false">Logout</router-link>
                    </li> -->
                  </ul>
                </div>
            </div>
            </div>
            <div class="card-body">
              <div class="row mt-3">
                <div class="col-12">
                  <div class="tab-content myaccount-tab-content" id="account-page-tab-content">
                    <div class="tab-pane fade show active" id="account-dashboard" role="tabpanel"
                      aria-labelledby="account-dashboard-tab">
                      <div class="myaccount-dashboard">
                        <p>Hello <strong>{{name}}</strong> (not {{name}}? <router-link to="/login">Sign
                            out</router-link>)</p>
                        <p>
                          From your account dashboard you can view your recent orders, manage your shipping and
                          billing addresses and <a href="javascript:void(0)">edit your password and account details</a>.
                        </p>
                      </div>
                    </div>
                    <div class="tab-pane fade" id="account-orders" role="tabpanel" aria-labelledby="account-orders-tab">
                      <my-orders :orders="myOrders" />
                    </div>
                    <div class="tab-pane fade" id="account-address" role="tabpanel"
                      aria-labelledby="account-address-tab">
                      <show-addresses :addresses="addresses" />
                    </div>
                    <div class="tab-pane fade" id="account-details" role="tabpanel"
                      aria-labelledby="account-details-tab">
                     <account-details />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Uren's Account Page Area End Here -->
    </main>
</template>

<script>
import MyOrders from './components/MyOrders.vue'
import ShowAddresses from './components/ShowAddresses.vue'
import AccountDetails from './components/AccountDetails.vue'
export default {
  name: "MyAccount",
  components: {MyOrders, ShowAddresses, AccountDetails},
  data() {
    return {
      name: "Client One",
      img: '/images/profil.png',
      myOrders: [
        {
          numOrder: "5364",
          date: "Mar 27, 2019",
          status: "Delivered",
          total: "1620.00 MRU for 2 items",
        },
        {
          numOrder: "7457",
          date: "Nov 10, 2020",
          status: "Delivered",
          total: "12458 MRU for 3 items",
        },
        {
          numOrder: "7845",
          date: "Dec 20, 2021",
          status: "On Hold",
          total: "5000 MRU for 1 item",
        },
      ],
      addresses: {
        billing: '1234 Heaven Stress, Beverly Hill OldYork UnitedState of Lorem',
        shipping: '1234 Heaven Stress, Beverly Hill OldYork UnitedState of Lorem',
      }
    }
  }
}
</script>

<style>

</style>
